export default __webpack_public_path__ + "static/media/bg.728bd507.png";